/* eslint react-refresh/only-export-components: ["error", {allowConstantExport: true, allowExportNames: ["useMicrositeRouteRegistry"]}] */
import {type ReactNode, createContext, useContext} from 'react';
import type {MicrositeRouteDefinition} from '../routes/types';

export type MicrositeRouteRegistry<LocaleId extends string = string> = {
  readonly landing: MicrositeRouteDefinition<`landing`, LocaleId>;
  readonly about?: MicrositeRouteDefinition<`about`, LocaleId>;
  readonly [key: string]: MicrositeRouteDefinition<string, LocaleId> | undefined;
};

const MicrositeRouteRegistryContext = createContext<MicrositeRouteRegistry | null>(null);

type MicrositeRouteRegistryProviderProps = {
  readonly routes: MicrositeRouteRegistry;
  readonly children: ReactNode;
};

export const MicrositeRouteRegistryProvider = ({routes, children}: MicrositeRouteRegistryProviderProps) => <MicrositeRouteRegistryContext.Provider value={routes}>{children}</MicrositeRouteRegistryContext.Provider>;

export const useMicrositeRouteRegistry = <LocaleId extends string = string>() => {
  const context = useContext(MicrositeRouteRegistryContext);

  if (!context) {
    throw new Error(`Microsite route registry missing. Wrap pages with MicrositeRouteRegistryProvider.`);
  }

  return context as MicrositeRouteRegistry<LocaleId>;
};
